import React  from 'react'
import InnerStyles from './InnerStyles.module.css'
import useCustomData from './useCustomData'
import { NavLink } from 'react-router-dom'
const SubTreatments = () => {

    const data=useCustomData(`https://backendsurgylife-1.onrender.com/uploads`)
    const data1=useCustomData (`https://backendsurgylife-1.onrender.com/location`)

  // const [data, setData] = useState([])

  // useEffect(()=>{
  //   axios.get(`http://localhost:4000/uploads`)
  //   .then((res)=>{
  //      setData(res.data)
  //   })
  //   .catch(err=>{
  //     alert("unable to fetch the Treatment data")
  //   })
    
  // })
  return (
    <main>
      <section className={InnerStyles.breadgum}>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
                         {/* <h1>{data.tname}</h1> */}
                         <h1>Sub Treatments</h1>

            </div>
          </div>

        </div>

      </section>

      <section className={`py-5 bx_shadow`}>
        <div className='container'>
          <div className='row'>
            <p>{data.tdesc}</p>
          {
            data1.map((treatments)=>{
              return(
                <div className='col-md-3'>
                  <div className='mb-3'>
                    
                 
                    <p className='my-3 text-center'>{treatments.tdesc}</p>
                    {/* <p>{treatments.trname}</p> */}
                       <h6 className={'my-3 text-center'}>
                      <NavLink className={InnerStyles.navtreatments} to='/sublocation'>{treatments.trname}</NavLink>
                      </h6>
                  </div>
                </div>
              )
            })
          }
          </div>
        </div>
      </section>

    </main>
  )
}

export default SubTreatments














// import Table from "react-bootstrap/Table"

//  <Table striped bordered hover>
//       <thead>
//         <tr>
//           <th>Name</th>
//          <th>Email</th>
//           <th>Phone</th>
//           <th>Address</th>

          
//         </tr>
//       </thead>

//       <tbody>
//          {
//           patientData.map((patient)=>{
//           return(
//             <tr>
//               <td>{patient.name}</td>
//               <td>{patient.email}</td>
//               <td>{patient.phone}</td>
//               <td>{patient.address}</td>

//             </tr>
//           )
//           })
//          }
//           </tbody>
//     </Table>
